// external imports
import React from 'react'
import { FlexColumn } from 'quark-web'
import { createFragmentContainer, graphql } from 'react-relay'
import { NavLink } from 'react-router-dom'
// local imports
import styles from './styles'
import { Accordion } from '~/components'

const ProductSelector = ({ currentFamily, currentCategory, currentProduct, selection }) => (
    <FlexColumn style={styles.container}>
        {Object.keys(selection)
            .sort((nameA, nameB) => nameA > nameB)
            .map(familyName => {
                const family = selection[familyName]
                // the node is active if the name matches
                return (
                    <Accordion
                        startActive={
                            (family.categories && family.name === currentFamily) ||
                            (!family.categories && family.name === currentFamily)
                        }
                        title={<div style={styles.accordionTitle}>{family.name}</div>}
                        key={family.name}
                    >
                        {family.categories &&
                            family.categories
                                .sort(({ name: nameA }, { name: nameB }) => nameA > nameB)
                                .map(category => (
                                    <Accordion
                                        startActive={category.name === currentCategory}
                                        title={<div style={styles.accordionTitle}>{category.name}</div>}
                                        key={category.name}
                                    >
                                        {category.products
                                            .sort(({ name: nameA }, { name: nameB }) => nameA > nameB)
                                            .map(product => (
                                                <NavLink
                                                    to={`/products/${family.name}/${category.name}/${product.name}`}
                                                    key={product.name}
                                                    style={styles.link}
                                                    activeStyle={styles.linkActive}
                                                >
                                                    <div style={styles.productLink}>
                                                        <div style={styles.itemDecoration} />
                                                        {product.name}
                                                    </div>
                                                </NavLink>
                                            ))}
                                    </Accordion>
                                ))}
                        {family.products &&
                            family.products.sort(({ name: nameA }, { name: nameB }) => nameA > nameB).map(product => (
                                <div style={styles.row} key={product.name}>
                                    <NavLink
                                        to={`/products/${family.name}/${product.name}`}
                                        key={product.name}
                                        style={styles.link}
                                        activeStyle={styles.linkActive}
                                    >
                                        <div style={styles.productLink}>
                                            <div style={styles.itemDecoration} />
                                            {product.name}
                                        </div>
                                    </NavLink>
                                </div>
                            ))}
                    </Accordion>
                )
            })}
    </FlexColumn>
)

export default ProductSelector



// WEBPACK FOOTER //
// ./src/views/Products/ProductSelector/index.js